import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../Header';
import '../../css/UserManagement/UserDetail.css';

const UsersDetail = () => {
  const [user, setUser] = useState(null);
  const [points, setPoints] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  // ✅ 한 페이지당 10개
  const itemsPerPage = 10;

  // ✅ 페이지 블록(10페이지씩)
  const pagesPerBlock = 10;

  // 파생 계산
  const totalPages = Math.max(1, Math.ceil(points.length / itemsPerPage));
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentPoints = points.slice(indexOfFirst, indexOfLast);

  // 현재 블록 계산 (0부터 시작)
  const currentBlock = Math.floor((currentPage - 1) / pagesPerBlock);
  const startPage = currentBlock * pagesPerBlock + 1;
  const endPage = Math.min(startPage + pagesPerBlock - 1, totalPages);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserDetail = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await axios.get(`http://13.124.224.246:7778/api/users/userinfo/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data?.success) {
          setUser(response.data.user);
        }
      } catch (error) {
        console.error('사용자 정보 로드 실패:', error);
      }
    };

    const fetchUserPoints = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const response = await axios.get(`http://13.124.224.246:7778/api/points/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.data?.success) {
          const sorted = response.data.points.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setPoints(sorted);
        }
      } catch (err) {
        console.error('포인트 정보 로드 실패:', err);
      }
    };

    fetchUserDetail();
    fetchUserPoints();
  }, [id]);

  // 데이터 길이 변경 시 현재 페이지 보정
  useEffect(() => {
    const tp = Math.max(1, Math.ceil(points.length / itemsPerPage));
    if (currentPage > tp) setCurrentPage(tp);
  }, [points, itemsPerPage, currentPage]);

  // 페이지 이동
  const goPrevPage = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const goNextPage = () => setCurrentPage((p) => Math.min(p + 1, totalPages));
  const goToPage = (p) => setCurrentPage(p);

  // ✅ 블록 이동 (이전 10 / 다음 10)
  const goPrevBlock = () => {
    if (startPage > 1) {
      const newStart = Math.max(1, startPage - pagesPerBlock);
      setCurrentPage(newStart); // 이전 블록의 시작 페이지로 이동
    }
  };
  const goNextBlock = () => {
    if (endPage < totalPages) {
      const newStart = endPage + 1;
      setCurrentPage(newStart); // 다음 블록의 시작 페이지로 이동
    }
  };

  const handleDelete = async () => {
    const confirmation = window.confirm('이 사용자를 삭제하시겠습니까?');
    if (!confirmation) return;

    try {
      const token = localStorage.getItem('token');
      if (!token) return;

      const response = await axios.delete(`http://13.124.224.246:7778/api/users/userinfo/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data?.success) {
        alert('사용자가 삭제되었습니다.');
        navigate('/users');
      } else {
        alert('사용자 삭제에 실패했습니다.');
      }
    } catch (error) {
      console.error('사용자 삭제 중 오류가 발생했습니다.', error);
    }
  };

  if (!user) return <div>로딩 중...</div>;

  return (
    <div className="user-detail-container">
      <Header />
      <h1 className="product-name">사용자 정보</h1>
      <div className="user-detail-content">
        <table className="user-detail-table">
          <tbody>
            <tr><th>닉네임</th><td>{user.nickname}</td></tr>
            <tr><th>이메일</th><td>{user.email}</td></tr>
            <tr><th>전화번호</th><td>{user.phoneNumber}</td></tr>
            <tr><th>추천 코드</th><td>{user.referralCode}</td></tr>
            <tr><th>이벤트 수신 동의</th><td>{user.eventAgree ? '동의' : '거부'}</td></tr>
          </tbody>
        </table>

        <h2>유저 포인트 내역</h2>
        <table className="user-detail-table">
          <thead>
            <tr>
              <th>유형</th>
              <th>금액</th>
              <th>총액</th>
              <th>설명</th>
              <th>생성일</th>
            </tr>
          </thead>
          <tbody>
            {currentPoints.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', opacity: 0.7 }}>
                  내역이 없습니다.
                </td>
              </tr>
            ) : (
              currentPoints.map((point) => (
                <tr key={point._id}>
                  <td>{point.type}</td>
                  <td>{Number(point.amount).toLocaleString()}</td>
                  <td>{Number(point.totalAmount).toLocaleString()}</td>
                  <td>{point.description || '-'}</td>
                  <td>{new Date(point.createdAt).toLocaleString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* ✅ 페이지네이션: 10페이지 블록 단위 */}
        <div className="pagination">
          {/* 이전 페이지 */}
          <button onClick={goPrevPage} disabled={currentPage === 1}>
            이전
          </button>

       

          {/* 현재 블록의 페이지 번호 */}
          {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
            const p = startPage + i;
            return (
              <button
                key={p}
                className={currentPage === p ? 'active' : ''}
                onClick={() => goToPage(p)}
              >
                {p}
              </button>
            );
          })}


          {/* 다음 페이지 */}
          <button onClick={goNextPage} disabled={currentPage === totalPages}>
            다음
          </button>
        </div>

        <div className="button-container" style={{ marginTop: '40px' }}>
          <button className="delete-button" onClick={handleDelete}>삭제</button>
        </div>
      </div>
    </div>
  );
};

export default UsersDetail;
